import { Trash2, Plus } from 'lucide-react';

export const MAX_PROOFS = 5;

/**
 * Prova social (a mesma do PIX, para qualquer mercado): ligada, até 5 textos
 * e o intervalo do ciclo. Só visual: `value` = { enabled, list, interval };
 * `market` nomeia os campos (há um editor por mercado na mesma tela).
 */
export default function SocialProofEditor({ value, onChange, hint, placeholder = 'Prova social', market = 'Brasil' }) {
    const { enabled, list, interval } = value;
    const proofs = list.length ? list : [''];
    const set = (patch) => onChange({ ...value, ...patch });

    const update = (idx, text) => set({ list: proofs.map((p, i) => (i === idx ? text : p)) });
    const remove = (idx) => {
        const next = proofs.filter((_, i) => i !== idx);
        set({ list: next.length ? next : [''] });
    };

    return (
        <div>
            <div className="flex items-center justify-between mb-2">
                <h3 className="spt-label mb-0">Prova Social</h3>
                <label className="relative inline-flex items-center cursor-pointer">
                    <input
                        type="checkbox"
                        className="sr-only peer"
                        aria-label={`Prova Social (${market})`}
                        checked={enabled}
                        onChange={(e) => set({ enabled: e.target.checked })}
                    />
                    <div className="w-11 h-6 bg-gray-600 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-500" />
                </label>
            </div>

            {enabled && (
                <>
                    <p className="spt-hint mb-3">{hint}</p>

                    <div className="flex flex-col gap-3">
                        {proofs.map((proof, idx) => (
                            <div key={idx} className="flex gap-2 items-start">
                                <span className="text-gray-400 text-sm mt-2 w-4">{idx + 1}.</span>
                                <input
                                    className="input3"
                                    value={proof}
                                    aria-label={`Prova social ${idx + 1} (${market})`}
                                    placeholder={`${placeholder} ${idx + 1}`}
                                    onChange={(e) => update(idx, e.target.value)}
                                />
                                {proofs.length > 1 && (
                                    <button type="button" className="mt-2" onClick={() => remove(idx)} title="Remover">
                                        <Trash2 size={14} className="text-red-400" />
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>

                    {proofs.length < MAX_PROOFS && (
                        <button type="button" className="btn-secondary mt-3" onClick={() => set({ list: [...proofs, ''] })}>
                            <Plus size={14} className="me-2" /> Adicionar prova social
                        </button>
                    )}

                    <div className="mt-4 flex items-center gap-3">
                        <label className="spt-label mb-0">Intervalo entre ciclos (segundos)</label>
                        <input
                            type="number"
                            className="input3 w-24"
                            min={5}
                            aria-label="Intervalo entre ciclos (segundos)"
                            value={interval}
                            onChange={(e) => set({ interval: e.target.value })}
                        />
                    </div>
                </>
            )}
        </div>
    );
}
